import axiosInstance from "./AxiosConfig";
import endpoints from "./endpoints";

export const walletServices = {
  fetchWalletDetails: () =>
    axiosInstance.get(endpoints.tokenEndPoints.walletDetails),
  updateWalletAddress: (id, walletAddress) =>
    axiosInstance.patch(
      `${endpoints.tokenEndPoints.updateWalletAddress}/${id}`,
      walletAddress
    ),
  addWalletAddress: (walletAddress) =>
    axiosInstance.post(
      endpoints.tokenEndPoints.addWalletAddress,
      walletAddress
    ),
  deleteWalletAddress: (id) =>
    axiosInstance.delete(
      `${endpoints.tokenEndPoints.deleteWalletAddress}/${id}`
    ),
  updateWalletStatus: (id) =>
    axiosInstance.patch(`${endpoints.tokenEndPoints.updateWalletStatus}/${id}`),
  userWalletInfo: (userId) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.userWalletInfo}/${userId}`),
};
